/*
 * Copyright (c) 2020 CalAmp Corp.  All Rights Reserved
 */
import React, {ReactNode} from 'react';
import Box from '@material-ui/core/Box';
import MenuItem from '@material-ui/core/MenuItem';
import {translate} from '@ion/core/src/locale/locale';
import {useIsPhone} from '@ion/dls/src/hooks/useMedia';
import Tooltip from '../components/tooltip/Tooltip';

// defines the cell menu item type definitions ...
export interface CellMenuItemType {
  onClick: (options: any, asset: any) => void;
  icon?: ReactNode;
  label: string;
  customStyles?: object;
  disabled?: boolean;
  paddingTop?: string;
  marginLeft?: string;
  showDisabledBulkTooltip?: boolean;
}

export const HeaderButtonTooltip = function(props) {
  return <Tooltip arrow placement={'top'} {...props} />;
};

/**
 * @CellMenuItem
 *
 * Defines the CellMenuItem component. This component defines the actions like
 * edit/delete for single/multiple cells.
 *
 * ```typescript
 *
 *   <CellMenuItem icon={<MapEditIcon />}
 *     onClick={editAsset}
 *     label={translate('admin-assets:grid.menu.editAsset')} />
 * ```
 */
export const CellMenuItem =  ({
  onClick,
  icon,
  label,
  paddingTop,
  marginLeft,
  customStyles = {},
  disabled = false,
  showDisabledBulkTooltip = false
}: CellMenuItemType) => {
  const isPhone = useIsPhone();
  return (
    <HeaderButtonTooltip title={translate('common:disabledBulkMessage')} disableHoverListener={!showDisabledBulkTooltip}>
      <MenuItem disabled={disabled} onClick={onClick} classes={{...customStyles}}>
        <Box display='flex' flexDirection='row' p={isPhone ? 0.3 : 1}>
          {icon && (
            <Box display='flex' alignItems='center' marginLeft={marginLeft} paddingTop={paddingTop}>
              {icon}
            </Box>
          )}
          {label && (
            <Box display='flex' ml={!isPhone ? 1 : 0}
              alignItems='center'>
              {label}
            </Box>
          )}
        </Box>
      </MenuItem>
    </HeaderButtonTooltip>
  );
};
